var intrinsicDimensionsFromProps = function intrinsicDimensionsFromProps(_ref) {
  var width = _ref.width,
    height = _ref.height;
  if (width && height) {
    return {
      width: width,
      height: height
    };
  }
  return {};
};
export default intrinsicDimensionsFromProps;